const Config = function() {};

Config.server = {
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    apiKey: process.env.REACT_APP_API_KEY,
    port: process.env.REACT_APP_PORT,
    environment: process.env.REACT_APP_ENVIROMENT
};

Config.app = {
    siteName: process.env.REACT_APP_SITE_NAME,
    logoName: process.env.REACT_APP_LOGO_NAME,
    domain: process.env.REACT_APP_DOMAIN,
    protocol: process.env.REACT_APP_PROTOCOL,
    photo: {
        maxFileSize: 6291456 /*6mb * 1024 * 1024*/,
        maxWidthOrHeight: 1920 
    },
    activeSliderClassName: "swiper-slide-active",
    gaKey: process.env.REACT_APP_GA_KEY,
    jointListApiKey: process.env.REACT_APP_JOIN_LIST_API_KEY,
    openGraphRenderHost: process.env.REACT_OPENGRAPH_RENDER_HOST,
    payment: {
        // it will show a popup with a discount code when the user is about to pay, 
        // if the user has a discount code available. This will work only for non-logged users
        showPopupDiscount: process.env.REACT_APP_PURCHASE_SHOW_DISCOUNT_POPUP === "true"
    },
    seo: {
        // The timeout from home should be longer than the normal one
        timeoutHomeReady: 5000,
        timeoutReady: 1500
    }
};

Config.format = {
    date: {
        defaultInputFieldFormat: "YYYY-MM-DDTHH:mm:ss",
        iso8601: "YYYY-MM-DDTHH:mm:ss.SSSZ",
        outputFieldDateEvent: "MMMM d, yyyy h:mm aa",
        outputFullDateFormat: "dddd, DD MMMM YYYY hh:mm:ss A z",
        outputDate: "DD MMM YYYY",
        outputDateTimeOrder: "DD MMM YYYY, hh:mm A",
        yearMonthDate: "YYYY-MM-DD"
    }
}

Config.auth = {
    google: {
        enabled: process.env.REACT_APP_AUTH_OPENID_ENABLED === "true",
        theme: "filled_black",
        shape: "rectangular",
        width: "300",
        type: "standard",
        client_id: process.env.REACT_APP_AUTH_OPENID_GOOGLE_CLIENT_ID,
        signin_itp_support: process.env.REACT_APP_AUTH_OPENID_GOOGLE_ITP_SUPPORT === "true",
        signup_itp_support: process.env.REACT_APP_AUTH_OPENID_GOOGLE_SINGUP_ITP_SUPPORT === "true",
        signin_data_text: "signin_with",
        signin_button_size: "large",
        signup_data_text: "signup_with",
        signup_button_size: "large",
    }
}

Config.captcha = {
    paramKey: "g-recaptcha-response",
    siteKey: process.env.REACT_APP_CAPTCHA_SITE_KEY
}

Config.map = {
    apiKey: process.env.REACT_APP_MAP_API_KEY,
    styles: [{"elementType":"geometry","stylers":[{"color":"#f5f5f5"}]},{"elementType":"labels","stylers":[{"visibility":"on"}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#f5f5f5"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#bdbdbd"}]},{"featureType":"administrative.neighborhood","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#dadada"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#c9c9c9"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]}]
};

Config.locale = {
  api: process.env.REACT_APP_LOCALE_API,
  url: "https://localise.biz/api/export/locale/%s.json?format=chrome&key=%s",
  locales: ['es'],
  localeFilename: ['es'],
  fallbacks: {
    'en-*': 'en'
  },
  dir: '/res/locales',
  prefixTemplateParameters: 'general.template_parameters.'
}

Config.model = {
    validation: {
        username: {
            regExp: /^[a-z0-9\-_.]+$/i,
            minLength: 4,
            maxLength: 35
        },
        title: {
            maxLength: 90
        },
        firstName: {
            minLength: 2,
            maxLength: 60
        },
        lastName: {
            minLength: 2,
            maxLength: 60
        },
        templateName: {
            maxLength: 100
        },
        email: {
            regExp: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
        },
        password: {
            regExp: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,20}$/,
            minLength: 6,
            maxLength: 20
        },
        pinCode: {
            regExp: /\d{6}/,
            maxLength: 6
        },
    }
}

Config.error = {
    userNotActivated: 4006,
    requireSignInCode: 4008,
    revertNotAllowed: 4015,
    notMortuaryOwner: 4020,
    claimTokenInvalid: 4033,
    claimAlreadyLinked: 4034
}

module.exports = Config;

